<template>
  <span
    class="status-badge"
    :class="[sizeClass, { 'status-badge--pill': pill }]"
    :style="badgeStyle"
  >
    <i v-if="showIcon" :class="['fa', statusConfig.icon]" class="status-badge__icon"></i>
    <span class="status-badge__text">{{ displayText }}</span>
  </span>
</template>

<script>
import { getStatusConfig } from '../../../../constants/orderStatus'

export default {
  name: 'StatusBadge',

  props: {
    status: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'md',
      validator: (val) => ['sm', 'md', 'lg'].includes(val)
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    pill: {
      type: Boolean,
      default: true
    },
    customLabel: {
      type: String,
      default: ''
    }
  },

  computed: {
    statusConfig () {
      return getStatusConfig(this.status)
    },

    badgeStyle () {
      return {
        backgroundColor: this.statusConfig.bg,
        color: this.statusConfig.text
      }
    },

    sizeClass () {
      return `status-badge--${this.size}`
    },

    displayText () {
      return this.customLabel || this.statusConfig.label
    }
  }
}
</script>

<style scoped>
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
  white-space: nowrap;
}

.status-badge--pill {
  border-radius: 9999px;
}

.status-badge--sm {
  padding: 2px 8px;
  font-size: 0.75rem;
}

.status-badge--md {
  padding: 4px 12px;
  font-size: 0.8125rem;
}

.status-badge--lg {
  padding: 6px 16px;
  font-size: 0.875rem;
}

.status-badge__icon {
  font-size: 0.75em;
}

.status-badge__text {
  line-height: 1;
}
</style>
